/**
 * Created by Abner Sui on 1/10/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Comment } from '../../../tamalelibs/models/workflow.model';
import { BriefConfig } from '../../../widgets/widgets.model';
import { Subject, Subscription } from 'rxjs';
import { WorkflowService } from '../../../tamalelibs/services/workflow.service';
import { debounceTime } from 'rxjs/operators';
import { UtilsService } from '../../../tamalelibs/services/utils.service';

export enum commentAction {
    CANCEL = 'CANCEL',
    SAVE = 'SAVE',
}

@Component({
    selector: 'tam-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit, OnDestroy {

    @Input() comments: Array<Comment>;
    @Input() comment: Comment;
    @Input() config: BriefConfig;

    @ViewChild('commentArea', { static: false }) commentArea;

    showPopup = false;
    content = '';

    private _autoFocusSubject$: Subject<any> = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _workflowService: WorkflowService,
        private _utils: UtilsService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._autoFocusSubject$.pipe(
                debounceTime(0),
            ).subscribe(action => {
                this.commentArea.nativeElement.focus();
            }),
        );
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    getAbbrNameForOneEntity(): string {
        return this._workflowService.getAbbrNameForOneEntity(this.comment.submitter);
    }

    getBackgroundColorById(id: string): string {
        return this._utils.getBackgroundColorById(id);
    }

    hasChild(): boolean {
        return this.comments.filter(item => item.parentId === this.comment.id).length > 0;
    }

    onClickCancel(event) {
        this.config.feedbackSubject$.next({
            type: commentAction.CANCEL,
        });
        this.showPopup = false;
    }

    onClickSave(event) {
        this.config.feedbackSubject$.next({
            type: commentAction.SAVE,
            payload: {
                comment: this.content,
                parentId: this.comment.id,
            },
        });
        this.showPopup = false;
    }

    reply(event) {
        this.showPopup = true;
        this._autoFocusSubject$.next('');
    }

}
